import { render, staticRenderFns } from "./MemberGroups.vue?vue&type=template&id=7367f028"
import script from "./MemberGroups.vue?vue&type=script&lang=js"
export * from "./MemberGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports